module.exports = __webpack_public_path__ + "static/img/s92.a69b37c1.png";